// extracted by mini-css-extract-plugin
module.exports = {"table":"Dillers_table__3_TQX","tableItem":"Dillers_tableItem__1_nB-","dillersTitle":"Dillers_dillersTitle__3h85a","wrapper-question":"Dillers_wrapper-question__2lrwj"};